import React from 'react';
import { ChatMessage } from './ChatMessage';
import { WHITE } from '../../data/constants';

export const ChatWidget = ({
  chatOpen,
  setChatOpen,
  chatMsgs,
  chatInput,
  setChatInput,
  chatLoading,
  chatBodyRef,
  sendChatMessage,
  suggestions
}) => {
  return (
    <>
      <button
        className="cbtn"
        onClick={() => setChatOpen(o => !o)}
        aria-label={chatOpen ? "Close chat" : "Chat with us"}
      >
        {chatMsgs.length <= 1 && <span className="cbtn-dot" />}
        {chatOpen ? (
          <svg viewBox="0 0 24 24" fill="none" stroke={WHITE} strokeWidth="2" strokeLinecap="round">
            <path d="M6 6l12 12M18 6L6 18"/>
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" fill="none" stroke={WHITE} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
          </svg>
        )}
      </button>

      <div className={`cwin${chatOpen ? " open" : ""}`}>
        <div className="cwin-head">
          <div>
            <div className="cwin-head-name">Nismay <em>Assistant</em></div>
            <div className="cwin-head-sub">Powered by Gemini</div>
          </div>
          <button className="cwin-close" onClick={() => setChatOpen(false)}>✕</button>
        </div>

        <div className="cwin-body" ref={chatBodyRef}>
          {chatMsgs.map((m, i) => (
            <ChatMessage key={i} role={m.role} text={m.text} />
          ))}
          {chatLoading && (
            <div className="cmsg bot typing"><span/><span/><span/></div>
          )}
        </div>

        {chatMsgs.length <= 1 && (
          <div className="cwin-suggest">
            {suggestions.map(s => (
              <button key={s} className="csug" onClick={() => sendChatMessage(s)}>{s}</button>
            ))}
          </div>
        )}

        <div className="cwin-input">
          <textarea
            rows={1}
            placeholder="Type a message…"
            value={chatInput}
            onChange={e => setChatInput(e.target.value)}
            onKeyDown={e => {
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                sendChatMessage(chatInput);
              }
            }}
          />
          <button
            className="cwin-send"
            disabled={!chatInput.trim() || chatLoading}
            onClick={() => sendChatMessage(chatInput)}
            aria-label="Send message"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke={WHITE} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 2L11 13"/><path d="M22 2l-7 20-4-9-9-4 20-7z"/>
            </svg>
          </button>
        </div>
      </div>
    </>
  );
};